import axios from "axios";

function resolveBackendUrl() {
  const raw = (process.env.REACT_APP_BACKEND_URL || "").trim();
  if (!raw) return "";
  if (/^http:\/\//i.test(raw)) {
    return raw.replace(/^http:\/\//i, "https://");
  }
  return raw;
}

const BACKEND_URL = resolveBackendUrl();
export const API = `${BACKEND_URL}/api`;
export const TOKEN_KEY = "pillet_session";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = getToken();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const artifactUrl = (blockId) =>
  `${API}/artifacts/${blockId}?t=${encodeURIComponent(getToken() || "")}`;

export default api;
